import React, { useEffect, useState } from "react";
import { Button, Form, Spin, Modal, Popconfirm, Dropdown, Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import "./Games.scss";
import { PAGE_SIZE } from "../../../constants";
import { Link } from "react-router-dom";
import SpinTheWheelGamesTable from "../../Tables/SpinTheWheelGames";
import {
	createSpinGame,
	deleteSpinGame,
	fetchSpinGames,
	resetDeleteStatusSpinGame,
	updateSpinGame,
} from "../../../actions/spinTheWheelGame";
import { ReactSVG } from "react-svg";
import SpinGameForm from "../../Forms/spinTheWheelGame";
import moment from "moment";

const SpinTheWheelGamesPage = () => {
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const { spinGames, loading } = useSelector((state) => state.fetchSpinGames);
	const { spinGameDeleted } = useSelector((state) => state.deleteSpinGame);
	const { status: updateStatus } = useSelector((state) => state.updateSpinGame);
	const [currentPage, setCurrentPage] = useState(1);
	const [pagination, setPagination] = useState({});
	const [spinGameId, setSpinGameId] = useState(null);
	const limit = Number(PAGE_SIZE) || 20;
	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
		form.resetFields();
		setSpinGameId(null);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		form.resetFields();
		setSpinGameId(null);
	};

	const handleEdit = (record) => {
		showModal();
		setSpinGameId(record.id);
		form.setFieldsValue({
			...record,
			start_date: moment(record.start_date).utcOffset("+08:00"),
			end_date: moment(record.end_date).utcOffset("+08:00"),
			redeem_expiry_date: moment(record.redeem_expiry_date).utcOffset("+08:00"),
		});
	};

	const handleClickDelete = (record) => {
		dispatch(deleteSpinGame(record.id));
	};

	const addNewGameClick = () => {
		showModal();
		form.resetFields();
	};

	const handleSubmitForm = (values) => {
		const newValues = values;
		newValues.start_date = values.start_date
			? moment(values.start_date).format("DD/MM/YYYY")
			: null;
		newValues.end_date = values.end_date
			? moment(values.end_date).format("DD/MM/YYYY")
			: null;
		newValues.redeem_expiry_date = values.redeem_expiry_date
			? moment(values.redeem_expiry_date).format("DD/MM/YYYY")
			: null;

		if (spinGameId) {
			dispatch(updateSpinGame(spinGameId, newValues));
		} else {
			dispatch(createSpinGame(newValues));
		}
		handleOk();
	};

	const withAction = (record) => {
		return (
			<span className="action" style={{ display: "flex" }}>
				<Dropdown.Button overlay={() => tableActionMenu(record)} />
			</span>
		);
	};

	const tableActionMenu = (record) => (
		<Menu className="table-action-menu">
			<Menu.Item key="view">
				<Link to={`/spin-the-wheel/games/${record?.id}`}>
					<Button className="btn-table-action-primary" type="link">
						Show
					</Button>
				</Link>
			</Menu.Item>
			<Menu.Item key="edit">
				<Button
					className="btn-table-action-primary"
					type="link"
					onClick={() => handleEdit(record)}
				>
					Edit
				</Button>
			</Menu.Item>
			<Menu.Item key="delete">
				<Popconfirm
					title="Are you sure to delete this one?"
					onConfirm={() => handleClickDelete(record)}
					okText="Yes"
					cancelText="No"
				>
					<Button type="link" className="btn-table-action-danger">
						Delete
					</Button>
				</Popconfirm>
			</Menu.Item>
		</Menu>
	);

	const handleFilter = (params) => {
		setCurrentPage(params.page);
		const startAt = (params.page - 1) * Number(PAGE_SIZE);
		dispatch(fetchSpinGames({ start: Number(startAt), count: PAGE_SIZE }));
	};

	const handleTableChange = (params) => {
		handleFilter(params);
	};

	useEffect(() => {
		if (spinGameDeleted) {
			dispatch(fetchSpinGames({ start: 0, count: PAGE_SIZE }));
			dispatch(resetDeleteStatusSpinGame());
		}
	}, [spinGameDeleted]);

	useEffect(() => {
		if (updateStatus === "SUCCEEDED")
			dispatch(fetchSpinGames({ start: 0, count: PAGE_SIZE }));
	}, [updateStatus]);

	useEffect(() => {
		if (spinGames) {
			setPagination({
				showSizeChanger: false,
				current: currentPage,
				pageSize: limit,
				total: spinGames.data.total,
				showTotal: (total) => `${total} Items`,
			});
		}
	}, [spinGames]);

	useEffect(() => {
		dispatch(fetchSpinGames({ start: 0, count: PAGE_SIZE }));
	}, []);

	return (
		<Spin spinning={loading} tip="Loading ...">
			<div className="spin-the-wheel-games-container">
				<div className="page-header">
					<div className="page-header-breadbrumb">
						<ul>
							<li>Games</li>
						</ul>
					</div>
					<div>
						<Button
							type="primary"
							className="btn btn-primary"
							onClick={addNewGameClick}
						>
							New Game
							<ReactSVG src="/icons/post-add.svg" />
						</Button>
					</div>
				</div>
				<div className="page-content">
					{spinGames && (
						<SpinTheWheelGamesTable
							rowKey="id"
							dataSource={spinGames.data.data}
							pagination={pagination}
							onChange2={handleTableChange}
							scrollHeight="calc(100vh - 275px)"
							actionWidth={50}
							withAction={withAction}
						/>
					)}
				</div>
				<Modal
					className="spin-form-modal"
					visible={isModalVisible}
					onOk={handleOk}
					onCancel={handleCancel}
					footer={null}
				>
					{spinGames && (
						<SpinGameForm
							form={form}
							spinGameId={spinGameId}
							handleOk={handleOk}
							handleSubmitForm={handleSubmitForm}
							handleCancel={handleCancel}
						/>
					)}
				</Modal>
			</div>
		</Spin>
	);
};

export default SpinTheWheelGamesPage;
